import React from 'react';

/**
 * ErrorBoundary — Captura errores de renderizado en cualquier componente hijo
 * y muestra un fallback UI en lugar de dejar la pantalla en blanco.
 * Es un class component porque React aún no soporta error boundaries con hooks.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReload = () => {
    // Deregister service workers y limpiar caches al recargar
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.unregister());
      });
    }
    if ('caches' in window) {
      caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
    }
    setTimeout(() => window.location.reload(true), 300);
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center p-6 bg-[#FDFBF7]"
          data-testid="error-boundary-fallback"
        >
          <div className="max-w-md w-full text-center space-y-4">
            <div className="text-6xl">⚠️</div>
            <h1 className="text-2xl font-bold text-[#1A1C18]">Algo salió mal</h1>
            <p className="text-[#6A736B]">
              La aplicación encontró un error inesperado. Por favor recarga la página para intentarlo de nuevo.
            </p>
            <button
              onClick={this.handleReload}
              data-testid="error-boundary-reload"
              className="w-full bg-[#2B4C3B] hover:bg-[#3A604D] text-white rounded-lg py-3 px-6 font-medium transition-colors"
            >
              Recargar aplicación
            </button>
            {this.state.error?.message && (
              <details className="text-left text-xs text-[#6A736B] mt-4">
                <summary className="cursor-pointer">Detalles técnicos</summary>
                <pre className="mt-2 p-2 bg-white border border-[#E8E5DD] rounded overflow-auto">
                  {String(this.state.error.message)}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
